// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetGraphDataRequest,
  TGetGraphDataModel,
  IMappers,
  TGetGraphDataResponse,
  IGetGraphDataResponse,
  IGetGraphDataResponseError,
} from './types';

export const defaultConfig: TGetGraphDataModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'valuation-b2b',
  pathApi: '/v1/get-graph-data/',
} as TGetGraphDataModel;

export function createGetGraphDataModel(parameters: IGetGraphDataRequest): TGetGraphDataModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetGraphDataOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetGraphDataRequest;
}

export async function fetchGetGraphData<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetGraphDataOptions<TResponse200, TResponse400>): Promise<TGetGraphDataResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetGraphDataModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetGraphDataResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetGraphDataResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetGraphDataResponse;
}
